// src/data/grammarQuestions/businessEmail2Questions.js
export const businessEmail2Questions = [
  {
    id: 1,
    koreanQuestion:
      "추가 단계나 서류가 있다면 마무리하는데 필요한 수락과정을, 알려주시기 바랍니다. 저는 신속하게 ______ 할 준비가 되어 있습니다.",
    question:
      "If there are any further steps or documentation required to finalize the acceptance process, please let me know. I am eager to ______ promptly.",
    choices: {
      A: "comply",
      B: "complete",
      C: "contact",
      D: "compare",
    },
    correctAnswer: "A",
    explanation: "A: 준수하다, 따르다 B: 완료하다 C: 연락하다 D: 비교하다 ",
    translation:
      "수락 과정을 마무리하기 위해 추가 단계나 서류가 필요하다면, 알려주시기 바랍니다. 저는 신속하게 준수할 준비가 되어 있습니다.",
    type: "business email",
  },
  {
    id: 2,
    koreanQuestion:
      "지난 몇 년 동안, 당신은 (현재) 보여줬습니다 주목할 만한 성실함 그리고 헌신을 교육_____ .",
    question:
      "Over the past years, you have shown remarkable diligence and commitment ______ learning.",
    choices: {
      A: "into",
      B: "towards",
      C: "for",
      D: "across",
    },
    correctAnswer: "B",
    explanation:
      "A: ~안으로 B: ~을 향해, ~에 대한 C: ~을 위한 D: ~을 가로질러 / 'commitment towards learning'은 '학습에 대한 헌신'을 의미하며, 'towards'는 어떤 것을 향한 태도나 감정을 나타낼 때 사용됩니다. 'commitment'와 함께 사용할 때는 'towards'가 가장 자연스러운 전치사입니다.",
    translation:
      "지난 몇 년 동안, 당신은 학습에 대한 주목할 만한 성실함과 헌신을 보여주었습니다.",
    type: "business email",
  },
  {
    id: 3,
    koreanQuestion:
      "당신의 노력은 넓히기 위한 당신의 지식을 그리고 개발하기 위한 새로운 스킬을  ______ 입니다.",
    question:
      "Your endeavor to broaden your knowledge and develop new skills is ______.",
    choices: {
      A: "comfortable",
      B: "considerable",
      C: "comparable",
      D: "commendable",
    },
    correctAnswer: "D",
    explanation:
      "A: 편안한 B: 상당한 C: 비교할 만한 D: 칭찬할 만한 / '당신의 노력은 칭찬할 만하다'라는 의미를 전달하기 위해 'commendable'이 가장 적절한 표현입니다. 이 문장은 중간에 수식어구가 많아 어렵게 구성된 유형입니다.",
    translation:
      "당신이 지식을 넓히고 새로운 기술을 개발하려는 노력은 칭찬할 만합니다.",
    type: "business email",
  },
  {
    id: 4,
    koreanQuestion:
      "보관하십시오 이 편지를 당신의 기록을 위해 증거로써 당신의 교육적 성취들.",
    question:
      "Please keep this letter ______ your records as proof of your educational achievements.",
    choices: {
      A: "on",
      B: "to",
      C: "for",
      D: "with",
    },
    correctAnswer: "C",
    explanation:
      "A: ~위에 B: ~에게 C: ~을 위한 D: ~와 함께 / 'keep this letter for your records'는 '기록을 위해 이 편지를 보관하다'라는 의미로, 목적이나 용도를 나타내는 전치사 'for'가 가장 적절합니다.",
    translation:
      "이 편지를 당신의 교육적 성취의 증거로 기록을 위해 보관하십시오.",
    type: "business email",
  },
  {
    id: 5,
    koreanQuestion:
      "우리 레스토랑은 제공한다 다양한 진미를, 어필하며 폭넓은 고객 ____ .",
    question:
      "Our restaurant serves various delicacies, appealing to a broad customer ______.",
    choices: {
      A: "base",
      B: "line",
      C: "case",
      D: "range",
    },
    correctAnswer: "A",
    explanation:
      "A: 기반, 기초 B: 선, 라인 C: 케이스, 경우 D: 범위 / 'customer base'는 '고객층' 또는 '고객 기반'을 의미하는 비즈니스 용어로, 레스토랑이 서비스를 제공하는 고객 그룹을 나타내는 데 가장 적절한 표현입니다.",
    translation:
      "우리 레스토랑은 다양한 진미를 제공하며, 폭넓은 고객층에게 어필합니다.",
    type: "business email",
  },
  {
    id: 6,
    koreanQuestion:
      "우리는 생각합니다 그.. 위치가 당신 부동산 잠재적으로 제공할 수 있다고 좋은 적합성으로 고객 _____ 및 접근성 측면에서 ",
    question:
      "We believe the location of your property could potentially serve as a good fit in terms of customer ______ and accessibility.",
    choices: {
      A: "dynamics",
      B: "demographics",
      C: "dialogues",
      D: "decorations",
    },
    correctAnswer: "B",
    explanation:
      "A: 역학, 동태 B: 인구통계학 C: 대화 D: 장식 / 'demographics'는 '인구통계학'이라는 의미로, 고객의 연령, 성별, 소득 등의 특성을 나타내는 용어입니다. 부동산 위치가 특정 고객층에게 적합한지 평가할 때 인구통계학적 요소를 고려하는 것이 일반적이므로 'demographics'가 가장 적절한 선택입니다.",
    translation:
      "우리는 귀하의 부동산 위치가 고객 인구통계학 및 접근성 측면에서 잠재적으로 좋은 적합성을 제공할 수 있다고 생각합니다.",
    type: "business email",
  },
  {
    id: 7,
    koreanQuestion:
      "부디 알려주실 수 있나요 만약 있다면 어떤 자리들이 가능한 또는 만약 당신이  ______ 하는지 공석들을 곧 그.. 저의 배경과 일치하는?",
    question:
      "Could you kindly let me know if there are any positions available or if you ______ openings shortly that align with my background?",
    choices: {
      A: "anticipate",
      B: "calculate",
      C: "nominate",
      D: "navigate",
    },
    correctAnswer: "A",
    explanation:
      "A: 예상하다 B: 계산하다 C: 지명하다 D: 항해하다, 탐색하다 / 'anticipate'는 '예상하다'라는 의미로, 미래에 있을 수 있는 공석에 대해 예측하는 상황에서 가장 적절한 표현입니다.",
    translation:
      "제가 가진 배경과 일치하는 자리가 있는지 또는 곧 자리가 생길 것으로 예상되는지 알려주시겠습니까?",
    type: "business email",
  },
  {
    id: 8,
    koreanQuestion:
      "저는 (현재) 글을 쓰는 중입니다 요청하기 위해 당신의 승인을 중요한 예산 ___ 을 위해 그... 필요한 지속적 성장과 성공에 우리 조직 ",
    question:
      "I am writing to request your approval for an important budget ______ that is necessary for the continued growth and success of our organization.",
    choices: {
      A: "application",
      B: "attention",
      C: "allocation",
      D: "extension",
    },
    correctAnswer: "C",
    explanation:
      "A: 신청, 응용 B: 주의, 관심 C: 할당, 배분 D: 연장, 확장 / 'allocation'은 '할당, 배분'이라는 의미로, 예산을 특정 목적이나 부서에 배분하는 것을 의미합니다. 조직의 성장과 성공을 위한 예산 배분에 대해 이야기하는 맥락에서 가장 적절한 표현입니다.",
    translation:
      "저는 우리 조직의 지속적인 성장과 성공을 위해 필요한 중요한 예산 할당에 대한 승인을 요청하기 위해 글을 씁니다.",
    type: "business email",
  },
  {
    id: 9,
    koreanQuestion:
      "우리는 (현재) ___ 분석했다 비용, 위험, 이점을 각 투자의, 포함하는 시장 연구 그리고 재무 예측들을 제안서 안에 명확성을 위해서 수익에 대한",
    question:
      "We've ______ analyzed the costs, risks, and benefits of each investment, included market studies and financial projections in the proposal for clarity on returns.",
    choices: {
      A: "clearly",
      B: "thoroughly",
      C: "lately",
      D: "shortly",
    },
    correctAnswer: "B",
    explanation:
      "A: 명확하게 B: 철저하게 C: 최근에 D: 곧, 간결하게 / 'thoroughly'는 '철저하게'라는 의미로, 투자의 비용, 위험, 이점을 완전하고 자세하게 분석했다는 맥락에서 가장 적절한 표현입니다.",
    translation:
      "우리는 각 투자의 비용, 위험 및 이점을 철저하게 분석했으며, 수익에 대한 명확성을 위해 제안서에 시장 연구 및 재무 예측을 포함했습니다.",
    type: "business email",
  },
  {
    id: 10,
    koreanQuestion:
      "알려주세요 만약 당신이 열려있는지 회의 혹은 화상 논의에 탐색하기 위해서 이 콜라보레이션을 더 ",
    question:
      "Please let me know if you would be open ______ a meeting or a virtual discussion to explore this collaboration further.",
    choices: {
      A: "to",
      B: "for",
      C: "with",
      D: "at",
    },
    correctAnswer: "A",
    explanation:
      "A: ~에게 B: ~을 위해 C: ~와 함께 D: ~에서 / 'be open to'는 '~에 대해 열려 있다, ~을 고려할 의향이 있다'라는 의미의 표현으로, 회의나 논의에 열려 있는지 묻는 맥락에서 'to'가 올바른 선택입니다.",
    translation:
      "귀하께서 이 협력 관계를 더 탐색하기 위한 회의나 화상 논의에 열려 있는지 알려주시기 바랍니다.",
    type: "business email",
  },
  {
    id: 11,
    koreanQuestion:
      "저는 연락 중입니다 문의하기 위해서 가능한 인턴십 기회들에 대해 Creative Solutions Ltd.내에서 디자인 부서 안.",
    question:
      "I am reaching out to inquire about potential internship opportunities ______ Creative Solutions Ltd. in the Design department.",
    choices: {
      A: "at",
      B: "within",
      C: "into",
      D: "for",
    },
    correctAnswer: "B",
    explanation:
      "A: ~에서 B: ~내에서 C: ~안으로 D: ~을 위해 / 'within'은 '~내에서'라는 의미로, 회사 내의 특정 부서에서의 기회를 언급할 때 가장 적절한 전치사입니다. 'at'은 장소나 위치를 나타내는 전치사로 회사에서 일하는 것을 표현할 때 사용할 수 있지만, 회사 '내부'의 특정 부서를 강조하는 이 맥락에서는 'within'이 더 정확합니다.",
    translation:
      "저는 Creative Solutions Ltd.의 디자인 부서 내에서 가능한 인턴십 기회에 대해 문의하기 위해 연락드립니다.",
    type: "business email",
  },
  {
    id: 12,
    koreanQuestion:
      "저는 가능합니다 대화가 당신의 편의에, 전화 또는 이메일을 통해, 그리고 저는 좋습니다 제공하는것이 어떤 추가적 정보를 그 .. 당신이 필요할지도 모르는.",
    question:
      "I am available for a conversation at your convenience, either ______ phone or email, and I am happy to provide any additional information you may need.",
    choices: {
      A: "by",
      B: "on",
      C: "with",
      D: "via",
    },
    correctAnswer: "D",
    explanation:
      "A: ~에 의해 B: ~위에 C: ~와 함께 D: ~을 통해, ~을 경유하여 / 'via'는 '~을 통해, ~을 경유하여'라는 의미로, 전화나 이메일과 같은 통신 수단을 나타낼 때 가장 적합한 전치사입니다. 이 문맥에서는 대화를 나눌 수단이나 방법을 표현하고 있으므로 'via'가 올바른 선택입니다.",
    translation:
      "저는 귀하의 편의에 맞춰 전화나 이메일을 통해 대화할 수 있으며, 필요하신 추가 정보를 기꺼이 제공해 드리겠습니다.",
    type: "business email",
  },
  {
    id: 13,
    koreanQuestion:
      "새로운 정책이 요구한다는 점을 고려하면 모든 직원들이 제출하도록 보고서를 금요일까지, 어떤 늦은 제출은 보고서를 제출할 것을 요구하며, 늦은 제출은 대상이 됩니다 벌칙을.",
    question:
      "____ the new policy requires all employees to submit reports by Friday, any late submissions will be subject to a penalty.",
    choices: {
      A: "As though",
      B: "Given that",
      C: "Nevertheless",
      D: "Besides",
    },
    correctAnswer: "B",
    explanation:
      "A: 마치 ~인 것처럼 B: ~을 고려하면 C: 그럼에도 불구하고 D: 게다가 / '~을 고려하면'의 의미로 접속사 'Given that'이 가장 적절합니다.",
    translation:
      "새로운 정책이 모든 직원들에게 금요일까지 보고서를 제출할 것을 요구한다는 점을 고려하면, 늦게 제출할 경우 벌칙을 받게 될 것입니다.",
    type: "business email",
  },
  {
    id: 14,
    koreanQuestion:
      "이 경험은 향상시켰을 뿐만 아니라 저의 기술적 능력 또한 ______ 했습니다 저의 이해를 사용자 중심 디자인 원칙에 대한 ",
    question:
      "This experience not only enhanced my technical skills but also ______ my understanding of user-centered design principles.",
    choices: {
      A: "decorated",
      B: "depended",
      C: "deepened",
      D: "departed",
    },
    correctAnswer: "C",
    explanation:
      "A: 장식했다 B: 의존했다 C: 깊게 했다, 심화시켰다 D: 떠났다 / 'deepen'은 '깊게 하다, 심화시키다'라는 의미로, 이해를 더 깊게 한다는 맥락에서 가장 적절한 표현입니다. 'not only A but also B' 구문에서 B 위치에 오는 동사로 문맥상 이해를 심화시킨다는 의미의 'deepened'가 가장 적합합니다.",
    translation:
      "이 경험은 제 기술적 능력을 향상시켰을 뿐만 아니라 사용자 중심 디자인 원칙에 대한 제 이해를 심화시켰습니다.",
    type: "business email",
  },
  {
    id: 15,
    koreanQuestion:
      "저는 (현재) 가졌습니다 기회를 리뷰할 당신 회사의 포트폴리오를 그리고 (현재) 확인했습니다. 주목할만한 가능성들을 그.. 실제로 ___ 우리의 새로운 요구사항들에",
    question:
      "I have had the chance to review your company portfolio and have identified remarkable possibilities that would indeed ______ our emerging requirements.",
    choices: {
      A: "suit",
      B: "spend",
      C: "serve",
      D: "separate",
    },
    correctAnswer: "A",
    explanation:
      "A: 적합하다 B: 소비하다 C: 제공하다 D: 분리하다 / 'suit'는 '적합하다, 맞다'라는 의미로, 회사의 요구사항에 적합하다는 맥락에서 가장 적절한 표현입니다. 참고) suit our requirements = 요구에 맞다, 적합하다",
    translation:
      "저는 귀사의 포트폴리오를 검토할 기회가 있었고 실제로 우리의 새로운 요구 사항에 적합한 주목할 만한 가능성을 확인했습니다.",
    type: "business email",
  },
  {
    id: 16,
    koreanQuestion:
      "판매 데이터가 보였기 때문에 상당한 증가를, CEO는 승인했습니다 확장 계획을.",
    question:
      "------- the sales data showed a significant increase, the CEO approved the expansion plan.",
    choices: {
      A: "While",
      B: "Since",
      C: "Despite",
      D: "Unless",
    },
    correctAnswer: "B",
    explanation:
      "A: ~하는 동안, ~인 반면에 B: ~이후로, ~이기 때문에 C: ~에도 불구하고 D: ~하지 않는 한 / '~을 고려하면, ~이기 때문에'라는 의미의 접속사 Since가 어울립니다.",
    translation:
      "판매 데이터가 상당한 증가를 보였기 때문에, CEO는 확장 계획을 승인했습니다.",
    type: "business email",
  },
  {
    id: 17,
    koreanQuestion:
      "저는 이해합니다 그.. 예상치 못한 상황이 발생할 수도 있단걸, 하지만 저는 정중하게 요청합니다 당신의 도움을 보장하는데 ____ 그리고 시기적절한 업데이트를 제 주문에 관해서",
    question:
      "I understand that unforeseen circumstances may arise, but I kindly request your assistance in ensuring ______ and timely updates regarding my order.",
    choices: {
      A: "transfer",
      B: "tendency",
      C: "testimony",
      D: "transparency",
    },
    correctAnswer: "D",
    explanation:
      "A: 전송, 이전 B: 경향, 성향 C: 증언 D: 투명성, 명료성 / 'transparency'는 '투명성, 명료성'이라는 의미로, 주문에 관한 명확하고 투명한 정보를 요청하는 맥락에서 가장 적절한 표현입니다. 비즈니스 이메일에서 투명성은 고객 신뢰를 구축하는 중요한 요소입니다.",
    translation:
      "예상치 못한 상황이 발생할 수 있다는 것을 이해하지만, 제 주문에 관한 투명하고 시기적절한 업데이트를 보장하는 데 도움을 요청합니다.",
    type: "business email",
  },
  {
    id: 18,
    koreanQuestion:
      "저는 현재 과정중에 있습니다 이사하는것 Springfield로 새로운 일자리 기회를 위해 그리고 저는 (현재) 찾고 있습니다 ____ 임대 부동산을",
    question:
      "I am currently in the process of relocating to Springfield for a new job opportunity and am looking for a ______ rental property.",
    choices: {
      A: "sizable",
      B: "suitable",
      C: "seasonal",
      D: "surplus",
    },
    correctAnswer: "B",
    explanation:
      "A: 상당한 크기의 B: 적합한 C: 계절적인 D: 잉여의, 여분의 / '적합한'이라는 의미의 'suitable'이 새로운 직업을 위해 이사하는 상황에서 임대 부동산을 찾는 맥락에 가장 적절합니다. 임대 부동산을 찾을 때는 자신의 필요와 상황에 '적합한(suitable)' 곳을 찾는 것이 중요합니다.",
    translation:
      "저는 현재 새로운 직업 기회를 위해 스프링필드로 이사하는 과정에 있으며 적합한 임대 부동산을 찾고 있습니다.",
    type: "business email",
  },
  {
    id: 19,
    koreanQuestion:
      "소프트웨어가 겪었음에도 불구하고 몇가지 버그들을 베타 테스트 중에, 출시 날짜는 변경되지 않았습니다.",
    question:
      "_______ the software encountered few bugs during beta testing, the launch date remained unchanged.",
    choices: {
      A: "Although",
      B: "Because",
      C: "Unless",
      D: "Despite",
    },
    correctAnswer: "A",
    explanation:
      "A: 비록 ~일지라도 B: ~때문에 C: ~하지 않는 한 D: ~에도 불구하고 / 'Although'는 '비록 ~일지라도'라는 의미로, 소프트웨어에 버그가 있었음에도 불구하고 출시 날짜가 변경되지 않았다는 대조적인 상황을 나타내는 데 적합합니다.",
    translation:
      "소프트웨어가 베타 테스트 중에 몇 가지 버그를 겪었음에도 불구하고, 출시 날짜는 변경되지 않았습니다.",
    type: "business email",
  },
  {
    id: 20,
    koreanQuestion:
      "IT 부서는 권장합니다 저장하는 것을 백업을  _____ 드라이브 그... 현재 연결되어 있는.",
    question:
      "The IT department recommends storing backups on ------- drive is currently connected.",
    choices: {
      A: "either",
      B: "both",
      C: "another",
      D: "whichever",
    },
    correctAnswer: "D",
    explanation:
      "A: 둘 중 하나 B: 둘 다 C: 다른 D: 어느 것이든, 무엇이든 / 'whichever'는 '어느 것이든, 무엇이든'이라는 의미로, 현재 연결되어 있는 어떤 드라이브에든 백업을 저장하라는 맥락에 가장 적합합니다.",
    translation:
      "IT 부서는 현재 연결되어 있는 어떤 드라이브에든 백업을 저장하는 것을 권장합니다.",
    type: "business email",
  },
  {
    id: 21,
    koreanQuestion:
      "결론적으로, 이 연구는 목표로 합니다 _____ 결과들을  그... 제안하는 상당한 개선을 불안 관리에 적용을 통해서 인지 행동치료",
    question:
      "In conclusion, this research aims to ______ results that suggest significant improvements in anxiety management through the application of cognitive behavioral therapy.",
    choices: {
      A: "remove",
      B: "receive",
      C: "yield",
      D: "consume",
    },
    correctAnswer: "C",
    explanation:
      "A: 제거하다 B: 받다 C: 산출하다, 생산하다 D: 소비하다 / 'yield'는 '산출하다, 생산하다'라는 의미로, 연구가 결과를 산출한다는 맥락에 가장 적합합니다. 연구는 결과를 제거하거나, 받거나, 소비하는 것이 아니라 생산하는 것이기 때문입니다.",
    translation:
      "결론적으로, 이 연구는 인지행동치료의 적용을 통한 불안 관리에 있어 상당한 개선을 시사하는 결과를 산출하는 것을 목표로 합니다.",
    type: "business email",
  },
  {
    id: 22,
    koreanQuestion:
      "저는 열망합니다 ______ 이 연구 프로젝트를 그리고 기여하기를 가치 있는 통찰력을 분야에 심리학 ",
    question:
      "I am eager to ______ this research project and contribute valuable insights to the field of psychology.",
    choices: {
      A: "convince",
      B: "commence",
      C: "cancel",
      D: "control",
    },
    correctAnswer: "B",
    explanation:
      "A: 설득하다 B: 시작하다 C: 취소하다 D: 통제하다 / 'commence'는 '시작하다'라는 의미로, 연구 프로젝트를 시작하고 싶다는 맥락에 가장 적합합니다. 다른 선택지들은 문맥상 적절하지 않습니다.",
    translation:
      "저는 이 연구 프로젝트를 시작하고 심리학 분야에 가치 있는 통찰력을 기여하기를 열망합니다.",
    type: "business email",
  },
  {
    id: 23,
    koreanQuestion:
      "직원들은 전달해야 합니다 어떤 긴급한 요청을 _____ 비서에게 연락가능한 그 순간에.",
    question:
      "Staff should forward any urgent request to _____ assistant is available at that moment.",
    choices: {
      A: "either",
      B: "both",
      C: "another",
      D: "whichever",
    },
    correctAnswer: "D",
    explanation:
      "A: 둘 중 하나 B: 둘 다 C: 다른 D: 어느 것이든, 무엇이든 / 'whichever'는 '어느 것이든, 무엇이든'이라는 의미로, 그 순간에 이용 가능한 어떤 비서에게든 전달해야 한다는 맥락에 가장 적합합니다. 다른 선택지들은 특정 비서나 비서들을 지정하는 표현으로 문맥상 적절하지 않습니다.",
    translation:
      "직원들은 모든 긴급한 요청을 그 순간에 이용 가능한 어떤 비서에게든 전달해야 합니다.",
    type: "business email",
  },
  {
    id: 24,
    koreanQuestion:
      "최종 승인 전에, 수행해 주십시오 ____ 검토를 첨부된 문서들.",
    question:
      "Before final approval, please conduct an _____ review of the attached documents.",
    choices: {
      A: "extensively",
      B: "extension",
      C: "extend",
      D: "extensive",
    },
    correctAnswer: "D",
    explanation:
      "A: 광범위하게(부사) B: 확장, 연장(명사) C: 확장하다(동사) D: 광범위한, 포괄적인(형용사) / 'extensive'는 '광범위한, 포괄적인'이라는 의미의 형용사로, 명사인 'review'를 수식하는 형용사가 필요한 문맥에 가장 적합합니다.",
    translation:
      "최종 승인 전에, 첨부된 문서들의 광범위한 검토를 수행해 주십시오.",
    type: "business email",
  },
  {
    id: 25,
    koreanQuestion:
      "출판사는 (현재) _____ 낮춰야 했습니다 출판사의 책 가격을 유지하기 위해 경쟁적으로 시장에서.",
    question:
      "The publisher has had to ______ lower its book prices to remain competitive in the market.",
    choices: {
      A: "slightly",
      B: "drastically",
      C: "evenly",
      D: "sparsely",
    },
    correctAnswer: "B",
    explanation:
      "A: 약간 B: 급격하게 C: 고르게 D: 드물게 / 'drastically'는 '급격하게, 과감하게'라는 의미로, 시장에서 경쟁력을 유지하기 위해 가격을 크게 낮춰야 했다는 맥락에 가장 적합합니다. 다른 선택지들은 문맥상 적절하지 않습니다.",
    translation:
      "출판사는 시장에서 경쟁력을 유지하기 위해 책 가격을 급격하게 낮춰야 했다.",
    type: "business email",
  },
  {
    id: 26,
    koreanQuestion:
      "_____ 로써 그.. 중요시하는 품질과 혁신을, 저는 (현재) 들었습니다 칭찬할만한 리뷰들을 귀하의 제품에 관한 그리고 더 알고 싶습니다 당신의 제품에 대해 ",
    question:
      "As ______ who values quality and innovation, I have heard commendable reviews about your offerings and would like to learn more about them.",
    choices: {
      A: "anyone",
      B: "everyone",
      C: "someone",
      D: "anything",
    },
    correctAnswer: "C",
    explanation:
      "A: 누구나 B: 모두 C: 누군가 D: 어떤 것 / 'someone'은 '누군가'라는 의미로, 문맥상 화자 자신을 지칭하는 단수 대명사가 필요합니다. 'As someone who values...'는 '~를 중요시하는 사람으로서'라는 의미로, 비즈니스 이메일에서 자신을 소개할 때 적절한 표현입니다. 다른 선택지들은 문맥에 맞지 않습니다.",
    translation:
      "품질과 혁신을 중요시하는 누군가로서, 저는 귀사의 제품에 대한 칭찬할 만한 리뷰를 들었으며 더 자세히 알고 싶습니다.",
    type: "business email",
  },
  {
    id: 27,
    koreanQuestion:
      "또한, 저는 ___ 합니다 알기위해서 만약 당신 회사가 제공하는지 어떤 맞춤형 옵션들 혹은 애프터판매 지원 서비스를 ",
    question:
      "Moreover, I am ______ to know if your company offers any customization options or after-sales support services.",
    choices: {
      A: "alike",
      B: "keen",
      C: "frequent",
      D: "visible",
    },
    correctAnswer: "B",
    explanation:
      "A: 비슷한 B: 열망하는, 간절히 바라는 C: 빈번한 D: 보이는, 눈에 띄는 / 'keen'은 '열망하는, 간절히 바라는'이라는 의미로, 'keen to know'는 '알고 싶어 하는, 알기를 열망하는'이라는 표현입니다. 이 문맥에서는 화자가 회사의 맞춤형 옵션이나 애프터서비스에 대해 알고 싶어하는 열의를 나타내므로 'keen'이 가장 적합합니다. 다른 선택지들은 문맥상 적절하지 않습니다.",
    translation:
      "또한, 저는 귀사가 맞춤형 옵션이나 판매 후 지원 서비스를 제공하는지 알고 싶습니다.",
    type: "business email",
  },
  {
    id: 28,
    koreanQuestion:
      "저는 전문 프리랜서입니다. ______ 콘텐츠제작, 디자인, 디지털 마케팅에",
    question:
      "I am a professional freelancer ______ in content creation, design, and digital marketing.",
    choices: {
      A: "specialize",
      B: "specialized",
      C: "specializes",
      D: "specializing",
    },
    correctAnswer: "D",
    explanation:
      "A: 전문화하다 B: 전문화된 C: 전문화하다(3인칭 단수) D: 전문화하는(현재분사) I am + specializing in ~ = 현재분사(진행형) → 현재 내가 하고 있는 전문 분야를 소개할 때 자연스럽고 자주 쓰이는 표현",
    translation:
      "저는 콘텐츠 제작, 디자인 및 디지털 마케팅 분야에 전문화하는 전문 프리랜서입니다.",
    type: "business email",
  },
  {
    id: 29,
    koreanQuestion:
      "저는 _____ 귀사를, International Brands Co. 그리고 저는 매우 감명받았습니다 일에 그.. 귀사가 하는 ",
    question:
      "I came ______ your company, International Brands Co., and I am very impressed with the work that you do.",
    choices: {
      A: "into",
      B: "upon",
      C: "across",
      D: "over",
    },
    correctAnswer: "C",
    explanation:
      "A: ~안으로 B: ~위에 C: 우연히 발견하다, 우연히 마주치다 D: ~넘어 / 'come across'는 '우연히 발견하다' 또는 '우연히 마주치다'라는 의미로, 이 문맥에서는 회사를 우연히 알게 되었다는 의미를 표현하기에 적합합니다.",
    translation:
      "저는 귀사인 International Brands Co.를 우연히 알게 되었으며, 귀사가 하는 일에 매우 감명받았습니다.",
    type: "business email",
  },
  {
    id: 30,
    koreanQuestion:
      "저는 자신합니다 그... 제가 ____ 될 것이고 그리고 기여할 수 있을 것입니다 긍적적으로 당신의 재능 있는 팀에 ",
    question:
      "I am confident that I will be an ______ and contribute positively to your talented team.",
    choices: {
      A: "aspect",
      B: "asset",
      C: "access",
      D: "effort",
    },
    correctAnswer: "B",
    explanation:
      "A: 측면, 양상 B: 자산, 가치 있는 사람/물건 C: 접근, 접속 D: 노력 / 'asset'은 '가치 있는 사람/물건'을 의미하며, 팀에 도움이 되는 구성원이 될 것이라는 의미로 적절합니다.",
    translation:
      "저는 귀사의 재능 있는 팀에 긍정적으로 기여할 수 있는 자산이 될 것이라고 확신합니다.",
    type: "business email",
  },
  {
    id: 31,
    koreanQuestion:
      "반영했을 때 우리의 대화를, 저는 깨달았습니다 어떻게 저의 말과 행동이 영향을 미쳤을지 당신에게.",
    question:
      "______ reflecting on our conversation, I realize how my words and behavior may have impacted you.",
    choices: {
      A: "Upon",
      B: "Over",
      C: "Across",
      D: "Beside",
    },
    correctAnswer: "A",
    explanation:
      "A: ~에 B: ~위에, ~넘어 C: 가로질러 D: ~옆에 / 'Upon'은 '~하자마자', '~했을 때'의 의미로 사용되며, 'upon reflecting'은 '반영했을 때'라는 의미로 문맥상 가장 적절합니다.",
    translation:
      "우리의 대화를 돌이켜 생각해보니, 내 말과 행동이 당신에게 어떤 영향을 미쳤는지 깨닫게 됩니다.",
    type: "business email",
  },
  {
    id: 32,
    koreanQuestion:
      "공급업체는 (현재) 증가시켜야 했습니다 이 업체의 인력을 맞추기 위해 예상치 못한 급증을 주문들에 있어서.",
    question:
      "The supplier has had to ______ increase its workforce to meet the unexpected surge in orders.",
    choices: {
      A: "marginally",
      B: "substantially",
      C: "evenly",
      D: "rarely",
    },
    correctAnswer: "B",
    explanation:
      "A: 약간, 미미하게 B: 상당히, 크게 C: 고르게, 균등하게 D: 드물게 / 'substantially'는 '상당히, 크게'라는 의미로, 예상치 못한 주문 급증에 대응하기 위해 인력을 크게 증가시켜야 했다는 맥락에 가장 적합합니다.",
    translation:
      "공급업체는 예상치 못한 주문 급증에 대응하기 위해 인력을 상당히 증가시켜야 했습니다.",
    type: "business email",
  },
  {
    id: 33,
    koreanQuestion:
      "준수하기 위해 새로운 안전 지침을, 제조 공장은 (현재) __ 업그레이드해야 했습니다 공장의 기계를.",
    question:
      "To comply with new safety guidelines, the manufacturing plant has had to _____ upgrade its machinery.",
    choices: {
      A: "barely",
      B: "promptly",
      C: "significantly",
      D: "evenly",
    },
    correctAnswer: "C",
    explanation:
      "A: 거의 ~않게 B: 신속하게 C: 상당히, 크게 D: 고르게 / 'significantly'는 '상당히, 크게'라는 의미로, 안전 지침을 준수하기 위해 기계를 크게 업그레이드해야 했다는 맥락에 가장 적합합니다.",
    translation:
      "새로운 안전 지침을 준수하기 위해, 제조 공장은 기계를 상당히 업그레이드해야 했습니다.",
    type: "business email",
  },
  {
    id: 34,
    koreanQuestion:
      "제안된 시간이 맞지 않는다면 귀하에게, 편안하게 _____ 하세요 대안.",
    question:
      "If the suggested time does not work for you, feel free to ______ an alternative.",
    choices: {
      A: "prepare",
      B: "protect",
      C: "propose",
      D: "perform",
    },
    correctAnswer: "C",
    explanation:
      "A: 준비하다 B: 보호하다 C: 제안하다 D: 수행하다 / 'propose'는 '제안하다'라는 의미로, 대안을 제시하는 맥락에 가장 적합합니다.",
    translation:
      "제안된 시간이 귀하에게 맞지 않는다면, 자유롭게 대안을 제안해 주십시오.",
    type: "business email",
  },

  {
    id: 35,
    koreanQuestion:
      "우리는 상기시켜드리고자 합니다 귀하의 다가오는 진료예약을 그... 예약된 리버사이드 메디컬 센터에",
    question:
      "We would like to remind you ______ your upcoming medical appointment scheduled at Riverside Medical Center.",
    choices: {
      A: "of",
      B: "for",
      C: "about",
      D: "with",
    },
    correctAnswer: "A",
    explanation:
      "A: ~에 대해 B: ~을 위해 C: ~에 관하여 D: ~와 함께 / 'remind someone of something'은 '누군가에게 무언가를 상기시키다'라는 표현으로, 예약을 상기시키는 맥락에 가장 적합합니다.",
    translation:
      "저희는 귀하께서 리버사이드 메디컬 센터에 예약된 다가오는 의료 예약에 대해 상기시켜 드리고자 합니다.",
    type: "business email",
  },
  {
    id: 36,
    koreanQuestion:
      "이 사전 통지는 만들 수 있게 합니다 어떤 필요한 ____ 를 스케줄에 그리고 보장합니다 그.. 다른 환자들이 수용될 수 있도록  효율적으로 ",
    question:
      "This advanced notice allows us to make any necessary ______ to the schedule and ensures that other patients can be accommodated efficiently.",
    choices: {
      A: "agreements",
      B: "achievements",
      C: "attachments",
      D: "adjustments",
    },
    correctAnswer: "D",
    explanation:
      "A: 합의 B: 성취 C: 첨부 D: 조정 / 'adjustments'는 '조정, 수정'을 의미하며, 일정을 변경하거나 조정하는 맥락에 적합합니다.",
    translation:
      "이 사전 통지는 저희가 일정에 필요한 조정을 할 수 있게 하고 다른 환자들도 효율적으로 수용할 수 있도록 합니다.",
    type: "business email",
  },

  {
    id: 37,
    koreanQuestion:
      "실패는  ___ 이러한 규칙에 그리고 규정들 결과를 낼 수 있습니다 벌금을 명시된대로 계약서에 .",
    question:
      "Failure to ______ to these rules and regulations can result in penalties as outlined in the agreement.",
    choices: {
      A: "apply",
      B: "adhere",
      C: "assign",
      D: "allow",
    },
    correctAnswer: "B",
    explanation:
      "A: 적용하다 B: 준수하다 C: 할당하다 D: 허용하다 / 'adhere to'는 '~을 준수하다, ~을 지키다'를 의미하며, 규칙이나 규정을 따르는 맥락에 가장 적합합니다.",
    translation:
      "이러한 규칙과 규정을 준수하지 않으면 계약서에 명시된 대로 벌금이 부과될 수 있습니다.",
    type: "business email",
  },
  {
    id: 38,
    koreanQuestion:
      "우리는 전념합니다 제공하는데 당신에게 고품질 경험을 그리고 보장하는데 그.. 당신이 받도록 ____한 가치를 당신의 구독으로부터.",
    question:
      "We are dedicated to providing you with a high-quality experience and ensuring that you receive the ______ value from your subscription.",
    choices: {
      A: "utmost",
      B: "outer",
      C: "upright",
      D: "unclear",
    },
    correctAnswer: "A",
    explanation:
      "A: 최고의, 최대한의 B: 바깥쪽의 C: 똑바로 선, 정직한 D: 불분명한 / utmost는 '최고의, 최대한의'를 의미하며, 구독에서 최대한의 가치를 얻는다는 맥락에 적합합니다.",
    translation:
      "저희는 귀하에게 고품질 경험을 제공하고 귀하의 구독으로부터 최고의 가치를 받을 수 있도록 보장하는 데 전념하고 있습니다.",
    type: "business email",
  },
  {
    id: 39,
    koreanQuestion:
      "우리의 대화에 따라 그..진행된 12월 1일에, 우리는 ____ 인정합니다 그.. 건설 서비스 계약이 시작할 것임을 2060/12/20에, 그리고 기대됩니다 끝날것으로 6월까지 2061년",
    question:
      "As per our conversation held on December 1st, we ______ acknowledge that the construction service agreement will commence on December 20, 2060, and is expected to be completed by June of 2061.",
    choices: {
      A: "beforehand",
      B: "completely",
      C: "hereby",
      D: "however",
    },
    correctAnswer: "C",
    explanation: "A: 미리, 사전에 B: 완전히 C: 이로써, 이에 D: 그러나",
    translation:
      "12월 1일에 진행된 우리의 대화에 따라, 우리는 이로써 건설 서비스 계약이 2060년 12월 20일에 시작되어 2061년 6월까지 완료될 것으로 예상됨을 인정합니다.",
    type: "business email",
  },
  {
    id: 40,
    koreanQuestion:
      "이 자금은 지급될 예정이다 일정에 따라 그...명시된 계약조건에, 그.. 당신이 알수 있을 것이다 첨부된 문서에서 ",
    question:
      "These funds will be disbursed ______ the schedule outlined in our terms of the agreement, which you will find attached to this letter.",
    choices: {
      A: "by",
      B: "over",
      C: "across",
      D: "for",
    },
    correctAnswer: "A",
    explanation:
      "A: ~에 의해, ~까지 B: ~에 걸쳐 C: ~을 가로질러 D: ~을 위해 / by는 '~에 따라, ~에 의해'를 의미하며, 일정에 따라 자금이 지급된다는 맥락에 적합합니다.",
    translation:
      "이 자금은 계약 조건에 명시된 일정에 따라 지급될 것이며, 해당 내용은 이 편지에 첨부된 문서에서 확인하실 수 있습니다.",
    type: "business email",
  },
  {
    id: 41,
    koreanQuestion:
      "우리는 기쁩니다 _____ 따뜻한 환영을 당신에게 새로운 팀원으로서 그린 리프 에너지의  ",
    question:
      "We are pleased to ______ a warm welcome to you as a new member of our team at Green Leaf Energy.",
    choices: {
      A: "expand",
      B: "express",
      C: "offer",
      D: "extend",
    },
    correctAnswer: "D",
    explanation:
      "A: 확장하다 B: 표현하다 C: 제공하다 D: 확장하다, 베풀다 / extend는 '환영이나 인사를 베풀다'라는 의미로, 'extend a warm welcome'(따뜻한 환영을 베풀다)는 비즈니스 이메일에서 자주 사용되는 표현입니다.",
    translation:
      "우리는 그린 리프 에너지의 새로운 팀원으로서 당신에게 따뜻한 환영을 전하게 되어 기쁩니다.",
    type: "business email",
  },
  {
    id: 42,
    koreanQuestion: "저는 현재 찾는 중입니다 아파트를 그.. ___ 나의 필요에",
    question: "I am currently searching for an apartment that _____ my needs.",
    choices: {
      A: "suit",
      B: "suits",
      C: "suited",
      D: "suiting",
    },
    correctAnswer: "B",
    explanation:
      "A: 맞다(동사 원형) B: 맞다(3인칭 단수형) C: 맞았다(과거형) D: 맞고 있는(현재분사) / that은 apartment를 선행사로 하는 관계대명사이며, apartment는 단수 명사이므로 3인칭 단수형 동사 suits가 올바른 선택입니다.",
    translation: "저는 현재 제 필요에 맞는 아파트를 찾고 있습니다.",
    type: "business email",
  },
  {
    id: 43,
    koreanQuestion:
      "단체들은 그... 혜택을 받는 캠페인으로부터 받을 것이다 자금을 ___ 할당 과정을 통해, 정기적 업데이트와 함께 그... 제공되는 기부자에게 그리고 대중에게",
    question:
      "Organizations benefiting from the campaign will receive funds through a _____ allocation process, with regular updates provided to donors and the public.",
    choices: {
      A: "transparent",
      B: "complex",
      C: "temporary",
      D: "random",
    },
    correctAnswer: "A",
    explanation:
      "A: 투명한 B: 복잡한 C: 임시적인 D: 무작위의 / transparent는 '투명한'이라는 의미로, 기부자와 대중에게 정기적인 업데이트를 제공한다는 맥락에서 자금 할당 과정이 투명하게 이루어진다는 것을 나타내는 가장 적절한 표현입니다.",
    translation:
      "캠페인의 혜택을 받는 단체들은 투명한 할당 과정을 통해 자금을 받게 되며, 기부자와 대중에게 정기적인 업데이트가 제공됩니다.",
    type: "business email",
  },
  {
    id: 44,
    koreanQuestion:
      "우리는 이해합니다 중요성을 이 기회 당신을 위해 그리고 최선을 다하고 있습니다 _____ 그.. 과정이 원활하고 편리하도록 가능한 ",
    question:
      "We understand the importance of this opportunity for you and are committed to _____ that the process is as smooth and convenient as possible.",
    choices: {
      A: "ensure",
      B: "ensuring",
      C: "ensured",
      D: "ensures",
    },
    correctAnswer: "B",
    explanation:
      "A: 보장하다(동사 원형) B: 보장하는(동명사) C: 보장된(과거분사) D: 보장한다(3인칭 단수) / 'be committed to' 다음에는 동명사(~ing)가 와야 하므로 'ensuring'이 올바른 선택입니다.",
    translation:
      "우리는 이 기회가 당신에게 중요하다는 것을 이해하고 있으며 그 과정이 가능한 한 원활하고 편리하도록 보장하는 데 최선을 다하고 있습니다.",
    type: "business email",
  },
  {
    id: 45,
    koreanQuestion:
      "만약 당신이 가진다면 어떤 충돌을 새로운 일정에, 주저하지 마세요 연락하는 것을 저에게, 그리고 우리는 최선을 다할 것입니다 _____  당신의 스케줄을",
    question:
      "If you have any conflicts with this new timing, do not hesitate to reach out to me, and we will do our best to _____ your schedule.",
    choices: {
      A: "accommodate",
      B: "confirm",
      C: "delay",
      D: "interrupt",
    },
    correctAnswer: "A",
    explanation:
      "A: 수용하다 B: 확인하다 C: 지연시키다 D: 방해하다 / 'accommodate'는 '수용하다, 맞추다'라는 의미로, 상대방의 일정에 맞추어 조정해 준다는 맥락에서 가장 적절한 표현입니다.",
    translation:
      "이 새로운 일정에 충돌이 있으시면 주저하지 마시고 저에게 연락해 주세요, 그러면 저희는 최선을 다해 귀하의 일정을 수용하겠습니다.",
    type: "business email",
  },
  {
    id: 46,
    koreanQuestion:
      "저는 연락 중입니다 소개하기 위해 당신에게 흥미로운 경력기회를 그.. 부합하는 당신의 놀라운 기술과 경험에",
    question:
      "I am reaching out to present you with an exciting career opportunity that aligns _____ your remarkable skills and experience.",
    choices: {
      A: "to",
      B: "by",
      C: "with",
      D: "for",
    },
    correctAnswer: "C",
    explanation:
      "A: ~에게 B: ~에 의해 C: ~와 함께 D: ~을 위해 / 'align with'는 '~와 일치하다, ~와 부합하다'라는 의미의 표현으로, 경력 기회가 기술과 경험에 부합한다는 맥락에서 'with'가 올바른 선택입니다.",
    translation:
      "저는 당신의 놀라운 기술과 경험에 부합하는 흥미로운 경력 기회를 제공하기 위해 연락드립니다.",
    type: "business email",
  },
  {
    id: 47,
    koreanQuestion:
      "견습 조종사들은 비행할 것입니다 지도하에 경험 많은 교관 그들의 초기 훈련 비행 동안",
    question:
      "The trainee pilots will fly _____ the guidance of an experienced instructor during their initial training flights.",
    choices: {
      A: "beyond",
      B: "among",
      C: "under",
      D: "beside",
    },
    correctAnswer: "C",
    explanation:
      "A: ~너머에 B: ~사이에 C: ~아래에 D: ~옆에 / 'under the guidance'는 '~의 지도 아래에'라는 의미로, 누군가의 지도나 감독 하에 있음을 나타낼 때 'under'를 사용합니다.",
    translation:
      "견습 조종사들은 초기 훈련 비행 동안 경험 많은 교관의 지도 아래에서 비행할 것입니다.",
    type: "business email",
  },
  {
    id: 48,
    koreanQuestion:
      "우리는 조직입니다 그...  헌신하는 _____ 생각을 자극하고 영향력있는 콘텐츠를 .",
    question:
      "We are an organization dedicated to _____ thought-provoking and socially impactful content.",
    choices: {
      A: "create",
      B: "creating",
      C: "created",
      D: "creates",
    },
    correctAnswer: "B",
    explanation:
      "A: 생성하다 B: 생성하는 것 C: 생성된 D: 생성한다 / 'dedicated to'는 전치사 'to' 다음에 동명사(gerund)가 와야 합니다. 따라서 'creating'이 올바른 선택입니다.",
    translation:
      "우리는 생각을 자극하고 사회적으로 영향력 있는 콘텐츠를 생성하는 데 헌신하는 조직입니다.",
    type: "business email",
  },
  {
    id: 49,
    koreanQuestion: "우리는 매우 감명받았습니다 _____ 당신의 기술과 경험에.",
    question: "We have been very impressed _____ your skills and experience.",
    choices: {
      A: "by",
      B: "to",
      C: "with",
      D: "of",
    },
    correctAnswer: "C",
    explanation:
      "A: ~에 의해 B: ~에게 C: ~와 함께 D: ~의 / 'impressed with'는 '~에 감명받다'라는 의미의 표현으로, 누군가의 기술이나 경험에 감명받았다는 맥락에서 'with'가 올바른 선택입니다. 'impressed by'도 사용할 수 있지만, 비즈니스 이메일에서는 'impressed with'가 더 일반적으로 사용됩니다.",
    translation: "우리는 당신의 기술과 경험에 매우 감명받았습니다.",
    type: "business email",
  },
  {
    id: 50,
    koreanQuestion:
      "저는 또한 계획합니다 ____ 책임들을 나의 팀에게, 보장하며 그.. 차질이 없도록 진행중인 프로젝트에 내가 자리를 비운 동안",
    question:
      "I also plan to _____ responsibilities to my team, ensuring that there is no disruption in ongoing projects while I am away.",
    choices: {
      A: "delegate",
      B: "delete",
      C: "delay",
      D: "describe",
    },
    correctAnswer: "A",
    explanation:
      "A: 위임하다 B: 삭제하다 C: 지연시키다 D: 설명하다 / 'delegate responsibilities'는 '책임을 위임하다'라는 의미로, 자리를 비울 때 팀원들에게 업무를 맡기는 상황에서 'delegate'가 가장 적절한 선택입니다.",
    translation:
      "나는 또한 내 팀에게 책임을 위임할 계획이며, 내가 자리를 비운 동안 진행 중인 프로젝트에 차질이 없도록 할 것입니다.",
    type: "business email",
  },
];
